import React from "react"
import { I18nextProvider } from "react-i18next"
import i18n from "../i18n/config"

export function I18nContext(props) {
  i18n.changeLanguage(props.pageContext.website_lang)
  return <I18nextProvider i18n={i18n}>{props.children}</I18nextProvider>
}
